import { CLOSE_MODAL, OPEN_MODAL } from './types';

export function openModal(name, props) {
  return {
    type: OPEN_MODAL,
    payload: { name, props },
  };
}

export function closeModal(name) {
  return {
    type: CLOSE_MODAL,
    payload: { name },
  };
}
